import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetByLevelId, GetByUserId } from '../../service/UserLevelService';
import { GetLatestBlogs } from '../../service/BlogService';
import { GetByReferUserId } from '../../service/UserReferService';
import { GetEpinsSummaryByUserId } from '../../service/EpinService';

function Dashboard() {
  const {
    isLoading, setIsLoading,
    setAppError, setAppErrorTitle, setAppErrorMessage, setAppErrorMode, appUser
  } = useGlobalContext();

  const id = appUser.id;

  //user level counts
  const [levelCounts, setLevelCounts] = useState({
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        setIsLoading(true);
        const updatedCounts = {};

        for (let levelId = 1; levelId <= 5; levelId++) {
          const res = await GetByLevelId(levelId, 1, 1, ""); // Only need count

          if (res && typeof res === "object" && "status" in res && res.status === 200) {
            updatedCounts[levelId] = res.total || 0;
          } else {
            updatedCounts[levelId] = 0;
          }
        }

        setLevelCounts(updatedCounts);
      } catch (err) {
        setAppError(true);
        setAppErrorTitle("Error loading member counts");
        setAppErrorMessage(err?.message || "Unexpected error occurred");
        setAppErrorMode("danger");
      } finally {
        setIsLoading(false);
      }
    };

    fetchCounts();
  }, []);


  //user refer count 
  const [referCount, setReferCount] = useState(0);
  const [keyword, setKeyword] = useState();

  const fetchReferCount = async () => {
    try {
      setIsLoading(true);
      const response = await GetByReferUserId(id, '', 1, 9999, keyword);
      if (response && response.status === 200) {
        setReferCount(response.total || 0);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load refer count");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchReferCount();
  }, []);

  /** user refers  */
  const [userRefers, setUserRefers] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchUserReferList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetByReferUserId(id, '', currentPage, limit, keyword);
      console.log("users", response);
      setUserRefers(response.userRefers || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserReferList(page);
  }, [page]);

  //acive members
  const [referCountActive, setReferCountActive] = useState(0);
  const fetchReferCountActive = async () => {
    try {
      setIsLoading(true);
      const response = await GetByReferUserId(id, 'active', 1, 9999, keyword);
      if (response && response.status === 200) {
        setReferCountActive(response.total || 0);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load refer count");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchReferCountActive();
  }, []);


  //latest blogs
  const [blogs, setBlogs] = useState([]);
  const fetchLatestBlogs = async () => {
    try {
      setIsLoading(true);
      const response = await GetLatestBlogs(4); // Load latest 4 blogs
      setBlogs(response.blogs || []);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load latest blogs");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchLatestBlogs();
  }, []);


  /** epin purchased count */
  const [totalEpinsCount, setTotalEpinsCount] = useState(0);
  const [totalUsedEpinsCount, setTotalUsedEpinsCount] = useState(0);
  const [totalBalanceEpinsCount, setTotalBalanceEpinsCount] = useState(0);

  const fetchEpinsSummary = async () => {
    try {
      setIsLoading(true);
      const response = await GetEpinsSummaryByUserId(id);
      if (response && response.status === 200) {
        setTotalEpinsCount(response.totalEpins || 0);
        setTotalUsedEpinsCount(response.usedEpins || 0);
        setTotalBalanceEpinsCount(response.balanceEpins || 0);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load epin count");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEpinsSummary();
  }, []);


  //user levels
  const [userLevels, setUserLevels] = useState([]);
  const fetchUserLevelList = async () => {
    try {
      setIsLoading(true);
      const response = await GetByUserId(id, 1, 9999, "");
      console.log("FULL RESPONSE: ", response);
      setUserLevels(response.userLevels || response.data?.userLevels || []);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserLevelList();
  }, []);

  const url = `${config.sponsorUrl}${appUser.mobile}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(url);
    alert("Copied the URL: " + url);
  };


  return (
    <>
      <Helmet>
        <title>Dashboard | {config.appName}</title>
      </Helmet>
      <div className='container'>

        <div className="panel-head d-flex justify-content-center align-items-center">
          <input
            type="text"
            value={url}
            readOnly
            id="urlInput"
            style={{ fontSize: '15px', width: '490px', padding: '5px' }}
          />
          <button
            onClick={copyToClipboard}
            style={{ fontSize: '15px', padding: '5px' }}
          >
            Copy URL
          </button>
        </div>
        &nbsp;&nbsp;&nbsp;

        {/* start of page */}
        <div className='page'>

          <div className='page-heading'>
            <h1>Welcome {appUser.name}..!!  (Member No.: A{appUser.id.toString().padStart(5, '0')})</h1>
          </div>

          {/* start of page content */}
          <div className='page-content'>

            {/* start of dashboard counter section */}
            <div className='dashboard-counter-section'>
              <div className='row'>
                <div className='col-12 col-sm-6 col-md-4 col-lg-4'>
                  <div className='dashboard-counter dashboard-counter-green'>
                    <i className="bi bi-person-badge"></i> {/* Changed icon */}
                    <span className='counter-value'>
                      {
                        userLevels.length > 0
                          ? userLevels
                            .filter(l => l.achieve === 0)
                            .sort((a, b) => b.level.levelId - a.level.levelId)[0]?.level.name ?? 'N/A'
                          : 'N/A'
                      }
                    </span>
                    <b>My Status</b>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-md-4 col-lg-4'>
                  <div className='dashboard-counter dashboard-counter-blue'>
                    <i className="bi bi-person-plus"></i> {/* Changed icon */}
                    <span className='counter-value'>{referCount}</span>
                    <b>Total Refers</b>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-md-4 col-lg-4'>
                  <div className='dashboard-counter dashboard-counter-red'>
                    <i className="bi bi-people-fill"></i> {/* Changed icon */}
                    <span className='counter-value'>{referCountActive}</span>
                    <b>Total Active Members</b>
                  </div>
                </div>
              </div>
              <div className='row g-3 pt-1'>
                <div className='col-12 col-sm-6 col-md-4 col-lg-4'>
                  <div className='dashboard-counter dashboard-counter-orange'>
                    <i className="bi bi-file-earmark-post"></i> {/* Changed icon */}
                    <span className='counter-value'>{totalEpinsCount}</span>
                    <b>Total Epins</b>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-md-4 col-lg-4'>
                  <div className='dashboard-counter dashboard-counter-brown'>
                    <i className="bi bi-file-earmark-check"></i> {/* Changed icon */}
                    <span className='counter-value'>{totalUsedEpinsCount}</span>
                    <b>Used Epins</b>
                  </div>
                </div>
                <div className='col-12 col-sm-6 col-md-4 col-lg-4'>
                  <div className='dashboard-counter dashboard-counter-pink'>
                    <i className="bi bi-wallet2"></i> {/* Changed icon */}
                    <span className='counter-value'>{totalBalanceEpinsCount}</span>
                    <b>Balance Epins</b>
                  </div>
                </div>
              </div>
            </div>

            {/* end of dashboard counter section */}

            {/* My Levels */}
            <div className='row'>
              <div className='col-lg-12 col-md-8 col-sm-12 col-12'>
                {/* start of portal content */}
                <div className="portal">
                  {/* start of portal title */}
                  <div className='portal-title-bar'>
                    <h4 className='portal-heading'>Latest Levels</h4>
                    <ul className='portal-actions d-none'>
                      <li>
                        <Link to='#'>
                          <i className="bi bi-arrow-clockwise"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* end of portal title */}

                  {/* start of portal body */}
                  <div className='portal-body'>
                    <div className='table-content'>
                      <div className="mobile-scroll">
                        <table className='table table-bordered table-condensed'>
                          <thead>
                            <tr>
                              <th>Level</th>
                              <th>Refer Count</th>
                              <th>Achieve</th>
                              <th>Status</th>
                              <th>Award</th>
                              <th>Award Given date / Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {userLevels && userLevels.length > 0 ? (
                              [...userLevels]
                                .sort((a, b) => b.id - a.id) // descending order
                                .slice(0, 5) // limit to 10 entries
                                .map((userLevel) => (
                                  <tr key={userLevel.id}
                                    className={
                                      userLevel.status === 'completed'
                                        ? 'status-completed'
                                        : userLevel.status === 'pending'
                                          ? 'status-pending'
                                          : userLevel.status === 'active'
                                            ? 'status-active'
                                            : ''
                                    }>
                                    <td>{userLevel.level.name}</td>
                                    <td>{userLevel.level.referCount}</td>
                                    <td>{userLevel.achieve === 1 ? 'Level Achieved' : 'Level Not Achieved'}</td>
                                    <td>
                                      {userLevel.status.charAt(0).toUpperCase() + userLevel.status.slice(1)}
                                    </td>
                                    <td>{userLevel.giftActual.name}</td>
                                    <td>
                                      {userLevel.status === "completed" ? (
                                        (() => {
                                          const date = new Date(userLevel.givenDate.date);
                                          const day = String(date.getDate()).padStart(2, '0');
                                          const month = String(date.getMonth() + 1).padStart(2, '0');
                                          const year = date.getFullYear();
                                          const formattedDate = `${day}-${month}-${year}`;
                                          const formattedRemarks = userLevel.remarks
                                            ? userLevel.remarks.charAt(0).toUpperCase() + userLevel.remarks.slice(1)
                                            : '';
                                          return (
                                            <>
                                              {formattedDate}
                                              <br />
                                              <small>{formattedRemarks}</small>
                                            </>
                                          );
                                        })()
                                      ) : userLevel.remarks ? (
                                        (() => {
                                          const formattedRemarks = userLevel.remarks.charAt(0).toUpperCase() + userLevel.remarks.slice(1);
                                          return (
                                            <>
                                              - <br />
                                              <small>{formattedRemarks}</small>
                                            </>
                                          );
                                        })()
                                      ) : (
                                        userLevel.status === "pending" ? "Award not yet given" : "-"
                                      )}
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr><td colSpan="9" className="text-center">No members found</td></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* end of portal title */}

                </div>
                {/* end of portal content */}
              </div>
            </div>
            <br></br>

            {/* My Refers */}
            <div className='row'>
              <div className='col-lg-12 col-md-8 col-sm-12 col-12'>
                {/* start of portal content */}
                <div className="portal">
                  {/* start of portal title */}
                  <div className='portal-title-bar'>
                    <h4 className='portal-heading'>Latest Refers</h4>
                    <ul className='portal-actions d-none'>
                      <li>
                        <Link to='#'>
                          <i className="bi bi-arrow-clockwise"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* end of portal title */}

                  {/* start of portal body */}
                  <div className='portal-body'>
                    <div className='table-content'>
                      <div className="mobile-scroll">
                        <table className='table table-bordered table-condensed'>
                          <thead>
                            <tr>
                              <th>Sl.no</th>
                              <th>Image</th>
                              <th>Member name</th>
                              <th>Mobile</th>
                              <th>Whatsapp</th>
                              <th>Email</th>
                              <th>Gender</th>
                              <th>City</th>
                              <th>Address</th>
                              <th>Pincode</th>
                            </tr>
                          </thead>
                          <tbody>
                            {userRefers && userRefers.length > 0 ? (
                              [...userRefers]
                                .sort((a, b) => b.id - a.id) // descending order by id (or use createdAt if available)
                                .slice(0, 5) // limit to 10 entries
                                .map((userRefer, index) => (
                                  <tr key={userRefer.id}>
                                    <td>{(page - 1) * limit + index + 1}</td>
                                    <td>
                                      <img
                                        src={`${config.imageBasePath}/user/${userRefer.user.id}.${userRefer.user.image}`}
                                        alt={userRefer.user.name}
                                        className='img-fluid image-xs'
                                      />
                                    </td>
                                    <td>{userRefer.user.name}</td>
                                    <td>{userRefer.user.mobile}</td>
                                    <td>{userRefer.user.whatsapp}</td>
                                    <td>{userRefer.user.email} </td>
                                    <td>{userRefer.user.gender.name}</td>
                                    <td>{userRefer.user.city.name}</td>
                                    <td>{userRefer.user.address}</td>
                                    <td>{userRefer.user.pincode}</td>
                                  </tr>
                                ))
                            ) : (
                              <tr><td colSpan="9" className="text-center">No members found</td></tr>
                            )}

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* end of portal title */}

                </div>
                {/* end of portal content */}
              </div>
            </div>
            <br></br>
            {/* lastest blog */}
            <div className='row'>
              <div className='col-lg-12 col-md-4 col-sm-12 col-12'>
                {/* start of portal content */}
                <div className="portal">
                  {/* start of portal title */}
                  <div className='portal-title-bar'>
                    <h4 className='portal-heading'>Latest Blogs</h4>
                    <ul className='portal-actions d-none'>
                      <li>
                        <Link to='#'>
                          <i className="bi bi-arrow-clockwise"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* end of portal title */}

                  {/* start of portal body */}
                  <div className='portal-body latest-blog'>
                    <div className='table-content'>
                      <div className="row g-4">
                        {blogs && blogs.length > 0 ? (
                          blogs.map((blog) => (
                            <div className="col-md-6 col-lg-4 col-xl-3" key={blog.id}>
                              <div className="card shadow-sm border-0 rounded-4 overflow-hidden position-relative">
                                {/* Top colored image placeholder with date badge */}
                                <div className="align-items-start justify-content-start position-relative" style={{ height: '180px' }}>
                                  <span className="badge bg-dark position-absolute top-0 start-0 m-2">
                                    {(() => {
                                      const date = new Date(blog.createdDateTime);
                                      const day = String(date.getDate()).padStart(2, '0');
                                      const month = date.toLocaleString('default', { month: 'short' }).toUpperCase();
                                      return `${day} ${month}`;
                                    })()}
                                  </span>
                                  <div className="justify-content-center align-items-center text-white fs-4 fw-bold">
                                    <Link to={`/blog/view/${blog.id}`}>
                                      <img
                                        src={`${config.imageBasePath}/blog/${blog.id}.${blog.image}`}
                                        alt={blog.name}
                                        className='img-fluid image-xs latest-blog-img'
                                      />
                                    </Link>
                                  </div>
                                </div>

                                {/* Blog content */}
                                <div className="card-body">
                                  <p className="text-secondary small mb-1 mt-1"><i className="bi bi-list me-1" ></i>{blog.blogCategory.name}</p>
                                  <Link to={`/blog/view/${blog.id}`} className="text-decoration-none text-dark w-bold">
                                    {blog.name?.substring(0, 20)}
                                  </Link>
                                  <p className="card-text text-muted">{blog.description?.substring(0, 80) + '...'}</p>
                                  <hr></hr>
                                  <p className="text-secondary small mb-0">
                                    <i className="bi bi-calendar-event"></i>{" "}
                                    {(() => {
                                      const date = new Date(blog.createdDateTime);
                                      const day = String(date.getDate()).padStart(2, '0');
                                      const month = String(date.getMonth() + 1).padStart(2, '0');
                                      const year = date.getFullYear();
                                      return `${day}-${month}-${year}`;
                                    })()}
                                    <i className="bi bi-clock ms-2 me-1"></i>
                                    {(() => {
                                      const date = new Date(blog.createdDateTime);
                                      let hours = date.getHours();
                                      const minutes = String(date.getMinutes()).padStart(2, '0');
                                      const ampm = hours >= 12 ? 'PM' : 'AM';
                                      hours = hours % 12;
                                      hours = hours ? hours : 12;
                                      return `${hours}:${minutes} ${ampm}`;
                                    })()}
                                  </p>
                                </div>
                              </div>
                            </div>

                          ))
                        ) : (
                          <div className="col-12 text-center">
                            <p>No blogs found</p>
                          </div>
                        )}
                      </div>

                      {/* View More Button */}
                      <div className="text-center mt-4">
                        <Link to="blog/list/grid" className="btn btn-primary px-4 rounded-pill">
                          View More
                        </Link>
                      </div>
                    </div>
                  </div>

                  {/* end of portal title */}

                </div>
                {/* end of portal content */}
              </div>

            </div>
          </div>
          {/* end of page content */}

        </div>
        {/* end of page */}

      </div >
    </>
  )
}

export default Dashboard